/**
 * @phxDeeplink
 */

import ngEnumeration from 'utility-ng-enumeration';
import * as ngKernel from 'utility-ng-kernel';
import { DeeplinkConfig } from './config/deeplink_config';
import { DeeplinksStateConfiguration } from './config/deeplink_state_config';

angular
  .module('capability-ng-deeplink', ['utility-ng-enumeration', 'utility-ng-kernel', 'data-ng-authentication'])
  .provider('ngDeeplinkConfig', DeeplinkConfig)
  .provider('ngDeeplinksStateConfiguration', DeeplinksStateConfiguration);

require('./config/deeplink_state_config');
require('./view/deeplink_controller');
require('./config/deeplink_config');

export * from './config/deeplink_state_config';
export * from './view/deeplink_controller';
export * from './config/deeplink_config';

export default 'capability-ng-deeplink';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-deeplink/src/main.ts